import { memo } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import type { RecentNotification } from '@kiute-tech/network-kiute-pro';
import Text from '@atoms/text/Text';
import { formatDateToFulltext } from '@utils/dates/dates';

export type NotificationBodyProps = {
    notif: RecentNotification;
};

const typeMap = (intl: IntlShape) =>
    ({
        create: intl.formatMessage({
            id: 'notifications.created.text',
            defaultMessage: 'pris un',
        }),
        update: intl.formatMessage({
            id: 'notifications.updated.text',
            defaultMessage: 'modifié son',
        }),
        delete: intl.formatMessage({
            id: 'notifications.delete.text',
            defaultMessage: 'annulé son',
        }),
    } as const);

const NotificationBody = ({ notif }: NotificationBodyProps) => {
    const intl = useIntl();
    const types = typeMap(intl);
    const body = intl.formatMessage(
        {
            id: 'notification.body',
            defaultMessage:
                '{who} à {type} rendez-vous: {what} le {when} avec {resources}',
        },
        {
            who: <Text bold>{notif.customerName}</Text>,
            type:
                // Since the backend only send an update notification when the MKP user pay his booking we always show a create notification
                notif.bookedPlatform === 'LE_CISEAU'
                    ? types.create
                    : types[notif.type],
            what: notif.services?.join(', '),
            when: (
                <Text bold>
                    {formatDateToFulltext(new Date(notif.timestamp))}
                </Text>
            ),
            resources: notif.humanResources?.join(', '),
        },
    );
    return <Text variant="body2">{body}</Text>;
};

export default memo(NotificationBody);
